import {
  SET_GAME_INFORMATION,
  SET_PLAYER_COUNT,
  SET_PLAYER_SORT_TYPE,
  SET_PLAYER_POSITION_FILTER,
  SET_MAINPAGE_VIEW,
  SET_SELECTED_PLAYER_STATS,
  SET_DISPLAY_PLAYERS,
  SET_GOBACK_BOOLEAN,
  SET_TEAMNAME_SELECTED_PLAYER,
  SET_TIME_HOURS,
  SET_TIME_MINUTES,
  SET_TIME_SECONDS,
  SET_MATCH_DATETIME,
  SET_PL_RES,
  SET_PLAYER_SEARCHED_NAME,
  SET_GAME_TEAMS,
  SET_TEAM_FILTER,
  SET_API_FLAG,
  SET_LEAGUE,
  SET_SELECTED_TIMEFRAME,
  SET_SLATE_ID,
  SET_COMPLETE_GAME_INFORMATION,
  SET_AVAILABLE_TIMEFRAMES,
  SET_AUTO_LINEUP_GEN_BAR_OPEN_FLAG,
  SET_IN_MEMORY_TIMEFRAMES,
  SET_HORIZONTAL_SCROLL_POSITION,
  SET_PL_STATUS,
  SET_PLAYER_LOCKED_COUNT,
  SET_PLAYER_FAVOURITE_COUNT,
  SET_PLAYER_EXCLUDED_COUNT,
  SET_PLAYER_LFD_COUNT,
  SET_IS_RESET_CLICKED,
  UPDATE_PLAYER_LFD_FLAG,
  SIGNOUT_REQUEST,
  DATA_REQUEST,
  DATA_SUCCESS,
  DATA_ERROR,
} from "./GameInformation";
import { persistor } from "../store";
export const signoutRequest = () => {
  console.log("Game Information Action --> SIGNOUT REQUEST ");
  return {
    type: SIGNOUT_REQUEST,
  };
};
export const setIsResetClicked = (value) => {
  console.log("Game Information Action --> Set Is Reset Count: ", value);
  return {
    type: SET_IS_RESET_CLICKED,
    is_reset_clicked: value,
  };
};
export const setPlayerLFDCount = (value) => {
  console.log(
    "LFD COUNTS Game Information Action --> Player LFD Count: ",
    value
  );
  return {
    type: SET_PLAYER_LFD_COUNT,
    slate_lfd_count: value,
  };
};
export const setPlayerFavouriteCount = (value) => {
  console.log("Game Information Action --> Player Favourite Count: ", value);
  return {
    type: SET_PLAYER_FAVOURITE_COUNT,
    player_favourite_count: value,
  };
};
export const setPlayerExcludedCount = (value) => {
  console.log("Game Information Action --> Player Excluded Count: ", value);
  return {
    type: SET_PLAYER_EXCLUDED_COUNT,
    player_excluded_count: value,
  };
};
export const setPlayerLockedCount = (value) => {
  console.log("Game Information Action --> Player Locked Count: ", value);
  return {
    type: SET_PLAYER_LOCKED_COUNT,
    player_locked_count: value,
  };
};
export const setPlayerStatus = (value) => {
  console.log("Game Information Action --> Player Status: ", value);
  return {
    type: SET_PL_STATUS,
    player_status: value,
  };
};
export const setHorizontalScrollPosition = (value) => {
  console.log("Game Information Action --> Horizontal scroll Pos: ", value);
  return {
    type: SET_HORIZONTAL_SCROLL_POSITION,
    horizontal_scroll_position: value,
  };
};
export const setInMemoryTimeframes = (value) => {
  console.log("Game Information Action --> in_memory_timeframe: ", value);
  return {
    type: SET_IN_MEMORY_TIMEFRAMES,
    in_memory_timeframe: value,
  };
};
export const setAvailableTimeframes = (value) => {
  console.log("Game Information Action: ", value);
  return {
    type: SET_AVAILABLE_TIMEFRAMES,
    available_timeframes: value,
  };
};
export const setSelectedTimeframe = (value) => {
  console.log("Game Information Action: ", value);
  return {
    type: SET_SELECTED_TIMEFRAME,
    selected_timeframe: value,
  };
};

export const setCompleteGameInformation = (value) => {
  console.log("Set Complete Game Information: ", value);
  return {
    type: SET_COMPLETE_GAME_INFORMATION,
    complete_game_information: value,
  };
};
export const setSlateID = (value) => {
  console.log("Set GOT API DATA FLAG: ", value);
  return {
    type: SET_SLATE_ID,
    slate_id: value,
  };
};
export const setLeague = (value) => {
  console.log("Set League: ", value);
  return {
    type: SET_LEAGUE,
    sports: value,
  };
};
export const setAutoLineupGenBarOpenFlag = (value) => {
  console.log("setAutoLineupGenBarOpenFlag: ", value);
  return {
    type: SET_AUTO_LINEUP_GEN_BAR_OPEN_FLAG,
    auto_lineup_gen_bar_open_flag: value,
  };
};

export const setAPIFlag = (value) => {
  console.log("Set GOT API DATA FLAG: ", value);
  return {
    type: SET_API_FLAG,
    got_api_data: value,
  };
};

export const setTeamFilter = (value) => {
  console.log("Set Game Teams Action: ", value);
  return {
    type: SET_TEAM_FILTER,
    filtered_team: value,
  };
};

export const setGameTeams = (value) => {
  console.log("Set Game Teams Action: ", value);
  return {
    type: SET_GAME_TEAMS,
    game_teams: value,
  };
};

export const setPlayerSearchedName = (value) => {
  console.log("Set Player Search Name Action: ", value);
  return {
    type: SET_PLAYER_SEARCHED_NAME,
    player_searched_name: value,
  };
};

export const setGameInformation = (value) => {
  console.log("Game Information Action: ", value);
  return {
    type: SET_GAME_INFORMATION,
    platform: value.platform,
    sports: value.sports,
    selected_timeframe: value.selected_timeframe,
    slate_id: value.slate_id,
  };
};

export const setPlayerCounts = (value) => {
  //alert("set player counts Action: " + value);
  return {
    type: SET_PLAYER_COUNT,
    player_counts: value,
  };
};

export const setTimeHours = (value) => {
  return {
    type: SET_TIME_HOURS,
    time_hours: value,
  };
};

export const setTimeMinutes = (value) => {
  return {
    type: SET_TIME_MINUTES,
    time_minutes: value,
  };
};

export const setTimeSeconds = (value) => {
  return {
    type: SET_TIME_SECONDS,
    time_seconds: value,
  };
};

export const setMatchDatetime = (value) => {
  return {
    type: SET_MATCH_DATETIME,
    match_datetime: value,
  };
};

export const setSortType = (value) => {
  return {
    type: SET_PLAYER_SORT_TYPE,
    player_sort_type: value.sort_name,
    player_sort_order: value.sort_order,
  };
};

export const setPositionFilter = (value) => {
  console.log("Setting player postion filter", value);
  return {
    type: SET_PLAYER_POSITION_FILTER,
    player_position_filter: value,
  };
};

export const setPlRes = (value) => {
  return {
    type: SET_PL_RES,
    pl_res: value,
  };
};

export const setMainPageView = (value) => {
  return {
    type: SET_MAINPAGE_VIEW,
    view_selected: value,
  };
};

export const setSelectedPlayerStats = (value) => {
  return {
    type: SET_SELECTED_PLAYER_STATS,
    selected_player_stats: value,
  };
};
export const updateDisplayPlayers = (value) => {
  persistor.flush();
  console.log("updateDisplayPlayers", value);
  return {
    type: UPDATE_PLAYER_LFD_FLAG,
    action: value,
  };
};

export const setDisplayPlayers = (value) => {
  persistor.flush();
  console.log("setDisplayPlayers", value);
  return {
    type: SET_DISPLAY_PLAYERS,
    display_players: value,
  };
};

export const goBackBoolean = (value) => {
  return {
    type: SET_GOBACK_BOOLEAN,
    go_back_boolean: value,
  };
};

export const setTeamNameOfSelectedPlayer = (value) => {
  return {
    type: SET_TEAMNAME_SELECTED_PLAYER,
    selected_player_teamname: value,
  };
};

export const dataRequest = () => ({ type: DATA_REQUEST });
export const dataSuccess = () => ({ type: DATA_SUCCESS });
export const dataError = (error) => ({ type: DATA_ERROR, payload: error });
